import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { SuncashRequest, SuncashValidateResponse } from '../model/suncash';
import { LoadWalletSchema } from '../model/api';
import { z } from 'zod';
import { APIType } from 'src/app/config/constant';


export const SUNCASH_DEPOSIT_FEE = 'SUNCASHDEPOSIT_KIOSK'
export const SUNCASH_WITHDRAWAL_FEE = 'SUNCASHWITHDRAWAL_KIOSK'

export const API_SUNCASH_DEPOSIT: APIType<
  { session: string, payment_type: 'SMARTPAY' | 'QRCODE', card: string, amount: number, fee: number, vat: number, pin: string, qr: string },
  z.infer<typeof LoadWalletSchema>
> = {
  method: 'loadWallet',
  params: {
    session: 'P01',
    payment_type: 'P02',
    card: 'P03',
    amount: 'P04',
    fee: 'P05',
    vat: 'P06',
    pin: 'P07',
    qr: 'P08',
  },
}

export const API_SUNCASH_WITHDRAW = {
  method: 'suncashWithdawal',
  params: {
    session: 'P01',
    payment_type: 'P02',
    card: 'P03',
    amount: 'P04',
    fee: 'P05',
    vat: 'P06',
    security_option: 'P07',
    pin: 'P08',
    tx_id: 'kiosk_trx_id'
  },
}

export const API_VOID_SUNCASH_WITHDRAW = {
  method: 'voidUnsuccessfulSuncashWithdrawal',
  params: {
    session: 'P01',
    tx_id: 'P02'
  }
}

@Injectable({
  providedIn: 'root',
})
export class SuncashService {
  constructor() {
  }
  private inputs: Subject<SuncashRequest> = new BehaviorSubject<SuncashRequest>(
    {} as any
  );
  private page: Subject<string> = new Subject<string>();
  private isDark: Subject<boolean> = new Subject<boolean>();
  private pin: Subject<string> = new Subject<string>();
  private cardNumber: Subject<string> = new Subject<string>();
  private category: Subject<string> = new Subject<string>();
  private reset: Subject<boolean> = new Subject<boolean>();
  private loginResponse: Subject<SuncashValidateResponse> =
    new BehaviorSubject<SuncashValidateResponse>({} as any);
  private denomination: Subject<any> = new BehaviorSubject<any>('');
  private fee: Subject<any> = new BehaviorSubject<any>("");
  private vat: Subject<any> = new BehaviorSubject<any>("");

  private allowCancel: Subject<boolean> = new Subject<boolean>();
  private allowSubmit: Subject<boolean> = new Subject<boolean>();

  get inputRequest$() {
    return this.inputs.asObservable();
  }

  get pageNumber$() {
    return this.page.asObservable();
  }

  get getDenomination$() {
    return this.denomination.asObservable();
  }
  get checkDark$() {
    return this.isDark.asObservable();
  }

  get getPin$() {
    return this.pin.asObservable();
  }

  get getCategory$() {
    return this.category.asObservable();
  }

  get getCardNumber$() {
    return this.cardNumber.asObservable();
  }
  get checkIfResetPin$() {
    return this.reset.asObservable();
  }
  get getLoginResponse$() {
    return this.loginResponse.asObservable();
  }
  get getFee$() {
    return this.fee.asObservable();
  }
  get getVat$() {
    return this.vat.asObservable();
  }
  get getallowCancel$() {
    return this.allowCancel.asObservable();
  }
  get getallowSubmit$() {
    return this.allowSubmit.asObservable();
  }

  updateDenomination(data: any) {
    this.denomination.next(data);
  }
  updateInputs(data: SuncashRequest) {
    this.inputs.next(data);
  }

  updatePage(data: string) {
    this.page.next(data);
  }

  updateClass(data: boolean) {
    this.isDark.next(data);
  }
  updatePin(data: string) {
    this.pin.next(data);
  }
  updateCardNumber(data: string) {
    this.cardNumber.next(data);
  }
  updateCategory(data: string) {
    this.category.next(data);
  }
  setResetPin(data: boolean) {
    this.reset.next(data);
  }
  updateLoginResponse(data: SuncashValidateResponse) {
    this.loginResponse.next(data);
  }
  updateFee(data: any) {
    this.fee.next(data);
  }
  updateVat(data: any) {
    this.vat.next(data);
  }

  updateallowCancel(data: boolean) {
    this.allowCancel.next(data);
  }
  updateallowSubmit(data: boolean) {
    this.allowSubmit.next(data);
  }
}
